import Component from 'react-pure-render/component';
import MaskUtils from 'portaltransparencia-common/libs/MaskUtils';
import PropTypes from 'prop-types';
import React from 'react';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';

export class LicitacaoDetalheParticipantes extends Component {
  static propTypes = {
    participantes: PropTypes.object.isRequired
  };

  renderParticipantes = data => {
    return (
      <tr key={data.get('id')}>
        <td>{data.get('pessoa')}</td>
        <td>{data.get('razaoSocial')}</td>
        <td>{data.get('nomeFantasia')}</td>
        <td>{MaskUtils.format(data.get('cnpj'))}</td>
      </tr>
    );
  };

  render() {
    const { participantes } = this.props;
    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader empty={participantes && participantes.isEmpty()}>
            <tr>
              <th>Participante</th>
              <th>Razão Social</th>
              <th>Nome Fantasia</th>
              <th>Documento</th>
            </tr>
          </TableHeader>
          <tbody>
            {participantes && participantes?.map(this.renderParticipantes)}
          </tbody>
        </table>
      </div>
    );
  }
}
